<h2>
  &nbsp;
</h2>
<div class="login-panel">
  <img src="assets/img/logo-black.png"/>
  <div class="lang-block">
    <app-language-picker></app-language-picker>
  </div>

  <form [formGroup]="form">
    <label>{{"home.login.customerNumber" | translate }}
      <input class="form-control" formControlName="customerNumber" type="text" id="customerNumber" autocomplete="on"
             [ngClass]="{error: form.get('customerNumber').errors && (form.get('customerNumber').touched || (form.get('customerNumber').dirty))}" />
    </label>
    <label>{{"home.login.username" | translate }}
      <input class="form-control" formControlName="username" type="text" id="username" autocomplete="on"
             [ngClass]="{error: form.get('username').errors && (form.get('username').touched || (form.get('username').dirty))}" />
    </label>
    <label>{{"home.login.password" | translate }}
      <input class="form-control" formControlName="password" type="password" id="password" autocomplete="on"
             [ngClass]="{error: form.get('password').errors && (form.get('password').touched || (form.get('password').dirty))}" />
    </label>
  </form>

  <div class="d-flex" style="margin-top: 20px;">
    <label>{{"home.login.rememberMe" | translate}}</label>
    <mat-checkbox [(ngModel)]="rememberMe" class="checkbox" style="margin-left: 15px;"></mat-checkbox>
  </div>

  <div class="validation-error" *ngIf="showError">
    <label>{{"home.login.invalidPassword" | translate}}</label>
  </div>

  <div class="d-flex"  style="margin-top: 10px;">
    <button mat-flat-button color="primary" (click)="submit()" style="width: 210px">{{'home.login.submit' | translate}}</button>
  </div>

  <div class="register-forgot-password" style="margin-top: 10px;">
    <button mat-flat-button (click)="passwordRecovery()">{{'home.login.passwordRecovery' | translate}}</button>
  </div>

  <div class="delimeter"></div>

  <div style="margin-top: 20px;">
    <button mat-flat-button color="white" (click)="register()" style="width: 210px">{{'home.login.register' | translate}}</button>
  </div>
</div>
